<mat-form-field appearance="fill">
    <mat-label>Nível de permissão</mat-label>
    <mat-select [(ngModel)]="valor" 
                [disabled]="!desabilitar"
                (selectionChange)="teste()"                
                placeholder="Sem permissão">
        <mat-option *ngFor="let opcao of opcoes" 
                    [value]="opcao.valor">{{opcao.descricao}}</mat-option>
    </mat-select>
</mat-form-field>